import { PlusContentListPage } from './PlusContentList.page';

export const plusContentRouter = {
  '/@/todays': PlusContentListPage,
};
